import type { DigitalCollectionId } from "./digitalArtworkCatalog";
import { artAsset } from "../lib/artAssets";

export type DigitalArtworkAsset = {
  collection: DigitalCollectionId;
  imageFile: string;
};

/** Local file mapping — synced from ~/Desktop/shanir_arts_work/digital-arts */
export const digitalArtworkAssets: Record<string, DigitalArtworkAsset> = {
  "2bf5fe3b-86d0-40ed-8e7c-c0c9bfd269ab": {
    collection: "morning-routine",
    imageFile: "morning_routine",
  },
  "2bf5fe3b-86d0-40ed-8e7c-c0c9bfd269av": {
    collection: "studio",
    imageFile: "autumnal_reverie",
  },
  "2bf5fe3b-86d0-40ed-8e7c-c0c9bfd269ak": {
    collection: "studio",
    imageFile: "lama",
  },
  "2bf5fe3b-86d0-40ed-8e7c-c0c9bfd269alp": {
    collection: "studio",
    imageFile: "love_at_the_corner",
  },
  "2bf5fe3b-86d0-40ed-8e7c-c0c9bfd2689a": {
    collection: "studio",
    imageFile: "versioning",
  },
  "8owwiofs": {
    collection: "studio",
    imageFile: "embrace_of_elements",
  },
  "ad97da46-92e0-4bf7-87fa-37b1e01e877c": {
    collection: "perceptions",
    imageFile: "perceptions_map",
  },
  "edb2ef43-1330-41cc-9070-15aa1d0a178e": {
    collection: "perceptions",
    imageFile: "day_night_intro",
  },
  "3a0a6b0d-5762-41ab-98c0-998b4e4c02ac": {
    collection: "perceptions",
    imageFile: "suninja",
  },
  "07bfa015-4557-402b-9ad7-ee6e6a3a0938": {
    collection: "perceptions",
    imageFile: "soaring_hawk",
  },
  "303b127e-f3c9-49b2-861a-1454ec83b127": {
    collection: "perceptions",
    imageFile: "ancient_prophecy",
  },
  "52d9ec9a-62b0-42f0-ab20-0f421a77208b": {
    collection: "perceptions",
    imageFile: "epiphany",
  },
  "438571ab-e662-4651-acc7-4fbdaaa84a5a": {
    collection: "perceptions",
    imageFile: "waves_of_false_reality",
  },
  "b5d53f88-eaec-4196-827a-d2fd956ca67c": {
    collection: "perceptions",
    imageFile: "forgotten_understanding",
  },
  "2bf5fe3b-86d0-40ed-8e7c-c0c9bfd269ac": {
    collection: "perceptions",
    imageFile: "perceptions_album_cover",
  },
  "intercontinental-conversation": {
    collection: "abstract",
    imageFile: "intercontinental-conversation",
  },
  "simba-portrait": {
    collection: "animals",
    imageFile: "simba_portrait",
  },
  "kim-and-handpan": {
    collection: "music-collabs",
    imageFile: "kim_and_handpan",
  },
  "bingo-nights-grandma": {
    collection: "studio",
    imageFile: "bingo_nights_grandma",
  },
  "close-talk": {
    collection: "studio",
    imageFile: "close_talk",
  },
  "craving-bamba-ba-li-bamba": {
    collection: "studio",
    imageFile: "craving_bamba_ba_li_bamba",
  },
  "meditating-chackra": {
    collection: "studio",
    imageFile: "meditating_chackra",
  },
  "nina": {
    collection: "studio",
    imageFile: "nina",
  },
  "nina-cool": {
    collection: "studio",
    imageFile: "nina_cool",
  },
  "nina-fantasy": {
    collection: "studio",
    imageFile: "nina_fantasy",
  },
  "sailing-away": {
    collection: "studio",
    imageFile: "sailing_away",
  },
  "sleeping-under-the-living-room-tent": {
    collection: "studio",
    imageFile: "sleeping_under_the_leaving_room_tent",
  },
  "stop-and-smell-the-flower": {
    collection: "studio",
    imageFile: "stop_and_smell_the_flower",
  },
  "the-argentinian-sloff": {
    collection: "studio",
    imageFile: "the_argentinian_sloff",
  },
  "the-fantasy-castle": {
    collection: "studio",
    imageFile: "the_fantasy_castle",
  },
  "under-the-covid-shadow": {
    collection: "studio",
    imageFile: "under_the_covid_shaddow",
  },
  "watermelon-head": {
    collection: "studio",
    imageFile: "watermellon_head",
  },
};

export function digitalArtworkImageUrl(
  collection: DigitalCollectionId,
  imageFile: string,
): string {
  return artAsset(`digital-arts/${collection}/${imageFile}.webp`);
}

export function digitalImageUrlForId(id: string): string | undefined {
  const asset = digitalArtworkAssets[id];
  if (!asset) return undefined;
  return digitalArtworkImageUrl(asset.collection, asset.imageFile);
}
